import { gql } from '@apollo/client';

import { TARGETING_RULE_DEFINITION, TARGETING_TERM_VALUES } from '../../../../../apis/graphql';

export const UPDATE_LINE_ITEM_TARGETING_TERM_VALUES = gql`
  mutation UpdateLineItemTargetingValues(
    $id: ID!
    $newTargetingValues: UpdateLineItemInputV5!
    $targetingRule: TargetingRuleInput
  ) {
    updateLineItem: updateLineItemV5(id: $id, input: $newTargetingValues, targetingRule: $targetingRule) {
      targetingTermValues {
        ...targetingTermValues
      }
      targetingRule {
        ...targetingRuleDefinition
      }
    }
  }
  ${TARGETING_TERM_VALUES}
  ${TARGETING_RULE_DEFINITION}
`;
